// import { Transform } from "class-transformer/decorators";
import { Transform, Type } from "class-transformer";
import { DateTime } from "luxon";
import { dateTimeFromSql } from "../common-types";

export interface SimpleItemData {
    id: number;
    name: string;
    created: string | DateTime;
    modified: string | DateTime;
}

export class SimpleItem implements SimpleItemData {
    id: number = null;
    name: string = '';
    originalName: string = '';

    @Transform(dateTimeFromSql(), { toClassOnly: true }) created: string | DateTime;
    @Transform(dateTimeFromSql(), { toClassOnly: true }) modified: string | DateTime;

    inEditMode: boolean = false;

    constructor() {
        this.originalName = this.name;
    }

    toggleEdit() {
        if (!this.inEditMode) this.originalName = this.name;
        this.inEditMode = !this.inEditMode;
    }

    cancelEdit() {
        this.name = this.originalName;
        this.inEditMode = false;
    }
}

export enum SimpleItemTypes {
    Qualification = 'Qualification',
    QualificationItem = 'QualificationItem',
    QualificationMoreItem = 'QualificationMoreItem',
}